import { render } from "./BackerCenterPaymentsSection.vue?vue&type=template&id=11931376"
import script from "./BackerCenterPaymentsSection.vue?vue&type=script&lang=js"
export * from "./BackerCenterPaymentsSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__